// /**
//  * Parcel - Add
//  */

// React
import React, { useState, useContext, useEffect } from 'react';
// Context
import AuthContext from '../../../../authContext';

// react hook form
import { Controller, useForm } from 'react-hook-form';

// UI
import theme from '../../../../theme';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
  Divider,
  FormControlLabel,
  Checkbox,
  withStyles,
  Tooltip,
  Theme,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from '../../../../components/Modal';
import AddItemsParcelsList from './addItemsParcelsList';
import AddItemsParcelsForm from './addItemsParcelsForm';
import AddInventoryItemsParcelsForm from './addInventoryItemsParcelsForm';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiArchiveOutline,
  mdiCubeOutline,
  mdiPlusCircle,
  mdiInformationOutline,
  mdiCheckCircle,
  mdiAlertOctagonOutline,
} from '@mdi/js';

// Client SDK
import Client from 'client-sdk/src/client';
import { GetAllWarehousesRequestBuilder } from 'client-sdk/src/warehouses/warehouses';

// Type
import {
  ParcelItems,
  PayloadCreate,
  SelectorProps,
} from '../../interfaces';
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel,
} from '../../../parcels/interfaces';
import { Warehouse } from '../../../warehouses/interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
  disablePrevDateByHour,
} from '../../../../utils/helpers';
import { Product } from '../../../products/interfaces';
import { Variant } from '../../../products/interfaces';
import { createParcelsActions } from '../../../parcels/actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Store } from '../../../../redux/reducers';
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectList,
  makeSelectLoading,
} from '../../../parcels/selectors';

import { useHistory } from 'react-router-dom';
import moment from 'moment';
import ListDimensions from '../../../orderPack/dimensionsList';
import MapPosition from '../../../centers/components/mapPosition';
import classes from './add.module.scss';
import enviroment from 'client-sdk/src/enviroments/enviroment';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

type Props = {
  create: (body: any) => void;
  onClose: () => void;
  warehouseId: number;
  createParcelsDispatch: (payload: PayloadCreate) => void;
};

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  deliveryDate: string;
  pickAddress: string;
  pickDate: string;
  pickTime: string;
  destinationId: number;
  deliveryType: string;
  id: number;
  items: ParcelItems[];
  deliveryStartTime: string;
  deliveryEndTime: string;
  sourceId: number;
  status: string;
  description: string;
  sourceWarehouseName: string;
  destinationWarehouseName: string;
  inboundType: "VIP" | "NORMAL"
};

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`;
  };
}

const inboundItems = [
  {
    name: "shrink",
    label: "شیرینک",
    info: "در این سرویس تمامی کالا های موجود در محموله با استفاده از پلاستیک حرارت دیده روکش می‌شوند."
  },
  {
    name: "labelAttachment",
    label: "الصاق لیبل",
    info: "لیبل و یا برچسب اختصاصی که میتواند شامل قیمت، لوگو و یا دیگر اطلاعات مورد نیاز شما باشد بر روی کالاها نصب میشود."
  },
  {
    name: "modifyPackage",
    label: "تغییر در ساختار کالا",
    info: "در صورتی که کالای ارسال شده نیاز به اعمال تغییرات به صورت سطحی در ساختار دارند می‌توانید از این سرویس استفاده نمایید."
  },
  {
    name: "repackage",
    label: "تغییر بسته‌بندی",
    info: "در این سرویس کالاهای محموله میتواند در هنگام ورود بسته‌بندی شوند و یا تغیراتی در بسته‌بندی کالاها اعمال شود."
  },
  {
    name: "kitting",
    label: "کیتینگ",
    info: "کیتینگ به معنی ساخت یک پکیج فروش با استفاده از چندین کالا است که میتواند به صورت مجزا ارسال شده و تحت عنوان یک کالا جای‌گذاری شود."
  },
]

const QCItems = [
  {
    name: "checkItems",
    label: "بررسی تمام کالا‌ها",
    info: "با انتخاب این گزینه تمامی کالاهای موجود در محموله به صورت تک به تک مورد بررسی قرارمیگیرند"
  },
  {
    name: "checkDate",
    label: "بررسی تاریخ تولید و انقضا",
  },
  {
    name: "test",
    label: "بررسی عملکرد کالا",
  },
  {
    name: "checkContents",
    label: "بررسی محتویات کارتن",
  },
  {
    name: "requestedQc",
    label: "کنترل کیفی درخواستی",
    info: "شما می‌توانید با انتخاب این گزینه کنترل کیفی مورد نظر خود را شخصی سازی نمایید"
  },
]

function Add(props: Props) {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const { register, handleSubmit, errors, control, watch, setValue, getValues } =
    useForm<Inputs>({
      defaultValues: {
        deliveryType: '',
        agentPhoneNumber: null,
        agentName: null,
        deliveryDate: disablePrevDateByHour(14),
        pickDate: disablePrevDateByHour(14),
        pickTime: null,
        deliveryStartTime: null,
        deliveryEndTime: null,
        description: null,
        inboundType: "NORMAL"
      },
    });

  const [items, setItems] = useState<any>([]);
  const [item, setItem] = useState<any>({});
  const [deliveryType, setDeliveryType] = useState<any>('BOX');
  const [transportationType, setTransportationType] = useState<any>('PARTNER');
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [id, setId] = useState<any>(1);
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [productObject, setProductObject] = useState<Product>({});
  const [variantObject, setVariantObject] = useState<Variant>({});
  const [hasExpirationDateTime, setHasExpirationDateTime] =
    React.useState(false);
  const [itemCount, setItemCount] = useState<any>(0);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [openAddInventoryItem, setOpenAddInventoryItem] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [locationModal, setLocationModal] = useState(false);
  const [destinationId, setDestinationId] = useState(enviroment.destinationId as number);
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  );
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
  const [parcelsData, setParcelsData] = React.useState({});
  const [options, setOptions] = React.useState<Warehouse[]>([]);
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [tab, setTab] = useState(1)
  const [packageChoice, setPackageChoice] = useState<string[]>([])
  const [dimensions, setDimensions] = useState<any>([]);
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 } as {
    lat: number;
    lng: number;
  });
  const [inboundDescription, setInboundDescription] = useState<string>("")
  const [qcDescription, setQcDescription] = useState<string>("")
  const [count, setCount] = useState('');
  const [weight, setWeight] = useState('');
  const [size, setSize] = useState('');
  const loading = openAutocomplete && options.length === 0;
  const values = getValues();


  useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const warehouses = response.data as any;
      if (active) {
        setOptions(warehouses as Warehouse[]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  useEffect(() => {
    if (values.inboundType == "VIP") {
      setPackageChoice([])
    }
  }, [values.inboundType])

  const addDimensions = () => {
    const newDimension = {
      count,
      length: size,
      width: size,
      height: size,
      weight
    };
    setDimensions([...dimensions, newDimension]);
    setCount('');
    setSize('');
    setWeight('');
  };

  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
  }, [dimensions]);

  const checkButtonDisabled = () => {
    return !size || !weight || !count;
  };

  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setDimensions([]);
  };

  const setUpdateStatus = () => {
    setCheckSubmit(true);
  };

  const onSubmit = (data: Inputs) => {
    let ronadTransportationDTO, deliveryStartTime, deliveryEndTime, parcelCustomizedOperationDTO;
    let {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      pickAddress,
      pickDate,
      pickTime,
      description,
      inboundType,
    } = data;


    ronadTransportationDTO = {
      lat: latLng.lat,
      lon: latLng.lng,
      pickAddress,
      pickDate,
      pickTime: pickTime?.substring(0, 2).concat(':00:00'),
    };

    parcelCustomizedOperationDTO = {
      shrink: packageChoice.indexOf("shrink") !== -1,
      labelAttachment: packageChoice.indexOf("labelAttachment") !== -1,
      modifyPackage: packageChoice.indexOf("modifyPackage") !== -1,
      repackage: packageChoice.indexOf("repackage") !== -1,
      kitting: packageChoice.indexOf("kitting") !== -1,
      checkItems: packageChoice.indexOf("checkItems") !== -1,
      checkDate: packageChoice.indexOf("checkDate") !== -1,
      test: packageChoice.indexOf("test") !== -1,
      checkContents: packageChoice.indexOf("checkContents") !== -1,
      requestedQc: packageChoice.indexOf("requestedQc") !== -1,
      inboundDescription,
      qcDescription
    }

    if (transportationType === 'PARTNER') {
      ronadTransportationDTO = {};
    } else {
      deliveryDate = pickDate
    }
    deliveryStartTime = convertPersianDigit2English(
      pickTime.substring(0, 2).concat(':00:00')
    )
    deliveryEndTime = convertPersianDigit2English(
      pickTime.substring(3, 5).concat(':00:00')
    )

    addParcel({
      agentName: agentName ? agentName : null,
      agentPhoneNumber: agentPhoneNumber ? agentPhoneNumber : null,
      deliveryType,
      items,
      partnerId: authContext?.user?.partnerId,
      deliveryDate,
      transportationType,
      description,
      ronadTransportationDTO,
      deliveryStartTime,
      deliveryEndTime,
      destinationId,
      inboundType,
      shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD')),
      parcelCustomizedOperationDTO
    });
  };

  const addParcel = (body: any) => {
    setParcelsData(body);
    handleOpenCheckConfirm();
  };

  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      hasExpirationDate,
      unitCost,
      productionDate,
      expirationDate
    } = body;
    setHasExpirationDateTime(hasExpirationDate);
    setId(id + 1);
    setProductObject(product);
    setVariantObject(variant);
    setItemCount(count);
    const idItem = product?.id;
    const variantId = variant?.id;
    const name = product?.name;
    setItemsInfo([
      ...itemsInfo,
      {
        id,
        productId: idItem,
        count,
        name,
        boxCount,
        countOfBox,
        product,
        variant,
      },
    ]);

    if (variantId) {
      setItem({
        variantId,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    } else {
      setItem({
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    }
    setItems([
      ...items,
      {
        variantId,
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
        inventoryItems: [
          {
            amount: Number(count),
            unitCost: unitCost ?? 0,
            productionDate: hasExpirationDate ? productionDate : null,
            expirationDate: hasExpirationDate ? expirationDate : null,
          },
        ],
      },
    ]);
    setOpenAddItem(false);
  };

  const createInventoryItemsToParcels = (
    body: AddInventoryItemCreateParcel[]
  ) => {
    setItems([...items, { ...item, inventoryItems: body }]);
    setOpenAddInventoryItem(false);
    setOpenAddItem(false);
  };

  const setConfirmDelete = (body: any) => {
    setOpenConfirmDelete(true);
    setItemDeleted(body);
  };

  const handleOpenCheckConfirm = () => {
    if (transportationType === 'PARTNER') {
      setCheckSubmit(true);
    } else {
      setOpenDimensions(true);
    }
  };

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false);
  };

  const handleClose = () => {
    setOpenConfirmDelete(false);
    setCheckSubmit(false);
  };

  const deleteItemsToParcels = () => {
    const newValue = items.filter((item: any) =>
      item.variantId
        ? item.variantId !== itemDeleted.variant.id
        : item.productId !== itemDeleted.productId
    );
    const newValueInfo = itemsInfo.filter((item: any) =>
      item.variantId
        ? item.variantId !== itemDeleted.variant.id
        : item.productId !== itemDeleted.productId
    );

    setItems(newValue);
    setItemsInfo(newValueInfo);
    setOpenAddItem(false);
    handleClose();
  };

  const handleCreateParcel = () => {
    const parcelData = { ...parcelsData, parcelPackages: dimensions };
    props.createParcelsDispatch({
      body: parcelData,
      pagination: {
        sourceWarehouseId: { equals: authContext.user?.warehouseId },
      },
      callback: () => {
        setParcelsData({});
        history.push('/parcels-sender');
      },
    });
    handleCloseDimensions();
    setCheckSubmit(false);
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
    setValue('pickTime', '');
  };
  useOnMount(() => {
    register(
      { name: 'deliveryDate', type: 'text' },
      { validate: required('تاریخ تحویل را وارد کنید') }
    );
    register({ name: 'pickDate', type: 'text', defaultValue: '' });
    register({ name: 'pickTime', type: 'text', defaultValue: '' });
  });

  const handleChange = event => {
    const index = packageChoice.indexOf(event.target.name)
    if (index > -1) {
      const newChoises = [...packageChoice]
      newChoises.splice(index, 1)
      setPackageChoice(newChoises)
    } else {
      setPackageChoice([...packageChoice, event.target.name]);
    }
  };

  return (
    <>
      <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
        ایجاد محموله
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)} className={classes.formWrapper}>
        <Typography className={classes.typographyCards}>
          اطلاعات محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name="inboundType"
                    label="* نوع محموله"
                    data-cy="inboundType"
                    as={
                      <TextField
                        variant="outlined"
                        select
                        fullWidth
                        error={
                          !!errors.inboundType && !!errors.inboundType
                        }
                      >
                        <MenuItem
                          value="NORMAL"
                          data-cy="time1"
                        >
                          عادی
                        </MenuItem>
                        <MenuItem
                          value="VIP"
                          data-cy="time2"
                        >
                          ویژه
                        </MenuItem>
                      </TextField>
                    }
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.inboundType &&
                    ' نوع محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="transportationTypeLabel">
                      * روش تحویل
                    </InputLabel>
                    <Select
                      label="* روش تحویل"
                      fullWidth
                      id="transportationType"
                      name="transportationType"
                      inputProps={{
                        name: 'transportationType',
                        id: 'transportationType',
                      }}
                      labelId="transportationTypeLabel"
                      value={transportationType}
                      onChange={e =>
                        setTransportationType(e.target.value)
                      }
                      inputRef={register({ required: true })}
                    >
                      <MenuItem value={'PARTNER'} data-cy="fromPartner">
                        ارسال توسط خودم
                      </MenuItem>
                      <MenuItem value={'RONAD'} data-cy="fromRonad">
                        جمع آوری توسط روناد
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <MuiPickersUtilsProvider
                    utils={JalaliUtils}
                    locale="fa"
                  >
                    <DatePicker
                      inputVariant="outlined"
                      id="deliveryDate"
                      name="deliveryDate"
                      label="* تاریخ تحویل محموله"
                      format="jYYYY/jMM/jDD"
                      minDate={disablePrevDateByHour(14)}
                      fullWidth
                      disablePast
                      autoOk
                      okLabel={null}
                      cancelLabel={null}
                      value={values.deliveryDate}
                      onChange={handleDeliveryDateChange}
                      error={errors.hasOwnProperty('deliveryDate')}
                    // helperText={
                    //   errors.deliveryDate && errors.deliveryDate.message
                    // }
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <FormHelperText error focused>
                  {errors?.deliveryDate &&
                    'تاریخ تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  {transportationType === 'RONAD' ? (<Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name="pickTime"
                    label={"* بازه تحویل به ناوگان"}
                    data-cy="pickTime"
                    as={
                      <TextField
                        variant="outlined"
                        select
                        fullWidth
                        error={
                          !!errors.pickTime && !!errors.pickTime
                        }
                      >
                        <MenuItem
                          disabled={checkHourisPast(
                            9,
                            values.deliveryDate
                          )}
                          value={'09-15'}
                          data-cy="time1"
                        >
                          {'9 الی 15'}
                        </MenuItem>
                        <MenuItem
                          disabled={checkHourisPast(
                            15,
                            values.deliveryDate
                          )}
                          value={'15-21'}
                          data-cy="time2"
                        >
                          {'15 الی 21'}
                        </MenuItem>
                      </TextField>
                    }
                  />) : (
                    <Controller
                      rules={{ required: true }}
                      style={{ width: '100%' }}
                      control={control}
                      name="pickTime"
                      label={"* بازه تحویل محموله"}
                      data-cy="pickTime"
                      as={
                        <TextField
                          variant="outlined"
                          select
                          fullWidth
                          error={
                            !!errors.pickTime && !!errors.pickTime
                          }
                        >
                          <MenuItem
                            disabled={checkHourisPast(
                              9,
                              values.deliveryDate
                            )}
                            value={'09-11'}
                            data-cy="time1"
                          >
                            {'9 الی 11'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              11,
                              values.deliveryDate
                            )}
                            value={'11-13'}
                            data-cy="time2"
                          >
                            {'11 الی 13'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'14-16'}
                            data-cy="time3"
                          >
                            {'14 الی 16'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'16-18'}
                            data-cy="time3"
                          >
                            {'16 الی 18 (ارسال خارج بازه)'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'18-20'}
                            data-cy="time3"
                          >
                            {'18 الی 20 (ارسال خارج بازه)'}
                          </MenuItem>
                        </TextField>
                      }
                    />
                  )}
                </div>
                <FormHelperText error focused>
                  {errors?.pickTime &&
                    ' بازه تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              {transportationType === 'RONAD' && <>
                <Grid item xs={9} alignItems="flex-end">
                  <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="pickAddress"
                        id="pickAddress"
                        label="آدرس جمع آوری"
                        inputRef={register({ required: false })}
                        error={errors.pickAddress && true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <Button
                      style={{ height: "56px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                      variant="outlined"
                      size="large"
                      component="span"
                      color="default"
                      onClick={() => setLocationModal(true)}>
                      {latLng.lat == 0 ? (<>
                        <span>اضافه کردن موقعیت مکانی</span>
                        <Icon
                          color={theme.palette.primary.main}
                          path={mdiPlusCircle}
                          size={1}
                          style={{ marginRight: "5px" }}
                        />
                      </>) : (
                        <>
                          <span>موقعیت شما با موفقیت ثبت شد</span>
                          <Icon
                            color={theme.palette.green.main}
                            path={mdiCheckCircle}
                            size={1}
                            style={{ marginRight: "5px" }}
                          />
                        </>
                      )}
                    </Button>
                  </div>
                </Grid>
              </>}
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="text"
                      id="agentName"
                      name="agentName"
                      label={transportationType === 'RONAD' ? "نام مسئول تحویل دهنده" : "نام مسئول حمل"}
                      inputRef={register({
                        required: false,
                      })}
                      error={errors.agentName && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {errors.agentName?.type === 'required' &&
                    'نام مسئول الزامی می باشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="text"
                      id="agentPhoneNumber"
                      name="agentPhoneNumber"
                      label={transportationType === 'RONAD' ? "شماره مسئول تحویل دهنده(۰۹۱۲۱۲۳۴۵۶۷)" : "شماره مسئول حمل(۰۹۱۲۱۲۳۴۵۶۷)"}
                      inputRef={register({
                        required: false,
                        minLength: 11,
                        maxLength: 11,
                        pattern: /[0-9]/
                      })}
                      error={errors.agentPhoneNumber && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {(errors?.agentPhoneNumber?.type === 'minLength' ||
                    errors?.agentPhoneNumber?.type === 'maxLength') &&
                    'شماره همراه ۱۱ رقم میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'required' &&
                    'شماره‌ همراه مسئول حمل الزامی می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText>
              </Grid>
              <Grid item xs={6} sm={6} lg={6}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    inputRef={register({ required: false })}
                    name='description'
                    label="توضیحات"
                    data-cy="warehouseAddress"
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className='notif' style={{marginTop: "8px"}}>
                  <Icon
                    path={mdiAlertOctagonOutline}
                    size={.8}
                  />
                  <Typography style={{ marginRight: "10px", fontSize: "14px" }}>
                    در اینباند ویژه کالاهای موجود در محموله حداکثر تا 3 ساعت کاری جای‌گذاری شده و با تعرفه ویژه محاسبه می‌شوند.
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Typography className={classes.typographyCards}>
          خدمات مازاد
        </Typography>
        <Card className={classes.card}>
          <CardContent style={{ padding: '0 0 12px 0' }}>
            <ul className={classes.tabContainer}>
              <li onClick={() => setTab(1)} className={classes.tabItems + " " + (tab == 1 && classes.active)}>اینباند</li>
              <li onClick={() => setTab(2)} className={classes.tabItems + " " + (tab == 2 && classes.active)}>کنترل کیفی</li>
            </ul>
            {tab == 1 && <Grid container justifyContent='space-between' style={{ marginTop: "24px" }}>
              {inboundItems.map(item => (
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleChange}
                        checked={packageChoice.includes(item.name)}
                        name={item.name}
                        color="primary"
                        disabled={values.inboundType == "VIP"}
                        size='small'
                      />
                    }
                    label={
                      <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: '400',
                            color: 'rgba(47, 72, 88, 1)',
                          }}
                        >
                          {item.label}
                        </Typography>
                        <HtmlTooltip title={item.info}>
                          <Icon
                            path={mdiInformationOutline}
                            size={.8}
                            color="#217AFF"
                            className={classes.icon}
                          />
                        </HtmlTooltip>
                      </div>
                    }
                  />
                </Grid>
              ))}
              <Grid style={{ marginTop: "30px" }} item xs={12}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name='inboundDescription'
                    placeholder="لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید."
                    label="توضیحات"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    data-cy="inboundDescription"
                    value={inboundDescription}
                    onChange={e => setInboundDescription(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>}
            {tab == 2 && <Grid container justifyContent='space-between' style={{ marginTop: "24px" }}>
              {QCItems.map(item => (<Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={handleChange}
                      checked={packageChoice.includes(item.name)}
                      name={item.name}
                      disabled={values.inboundType == "VIP"}
                      color="primary"
                      size='small'
                    />
                  }
                  label={
                    <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                      <Typography
                        style={{
                          fontSize: '16px',
                          fontWeight: '400',
                          color: 'rgba(47, 72, 88, 1)',
                        }}
                      >
                        {item.label}
                      </Typography>
                      {item.info && <HtmlTooltip title={item.info}>
                        <Icon
                          path={mdiInformationOutline}
                          size={.8}
                          color="#217AFF"
                          className={classes.icon}
                        />
                      </HtmlTooltip>}
                    </div>
                  }
                />
              </Grid>))}
              <Grid style={{ marginTop: "30px" }} item xs={12}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name='qcDescription'
                    placeholder="لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید."
                    label="توضیحات"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    data-cy="qcDescription"
                    value={qcDescription}
                    onChange={e => setQcDescription(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>}
            <Grid container className='notif'>
              <Icon
                path={mdiAlertOctagonOutline}
                size={.8}
              />
              <Typography style={{ marginRight: "10px", fontSize: "14px" }}>
                درخواست‌های مورد نظر بر روی تمامی کالاهای محموله اعمال می گردد.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
        {["65", "2", "119"].includes(authContext?.user?.partnerId) && <>
          <Typography className={classes.typographyCards}>
            اطلاعات انبار مقصد
          </Typography>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <Autocomplete
                      style={{ width: '100%' }}
                      open={openAutocomplete}
                      onOpen={() => {
                        setOpenAutocomplete(true);
                      }}
                      onClose={() => {
                        setOpenAutocomplete(false);
                      }}
                      getOptionSelected={(option, value) =>
                        option.name === value.name
                      }
                      getOptionLabel={option => option.name}
                      options={options}
                      loading={loading}
                      onChange={(event: any, newValue: any | null) => {
                        setDestinationId(newValue?.id);
                        setValueWarehouse(newValue);
                      }}
                      renderInput={params => (
                        <TextField
                          variant="outlined"
                          {...params}
                          label="انبار مقصد"
                          inputRef={register({ required: false })}
                          name="admin"
                          id="admin"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress
                                    color="inherit"
                                    size={20}
                                  />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>
                </Grid>
                <Grid item xs={9} sm={9} lg={9} spacing={2}>
                  <div className={classes.item}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      // defaultValue={' '}
                      value={valueWarehouse ? valueWarehouse?.address : ''}
                      label="آدرس انبار"
                      inputProps={{ readOnly: true }}
                      data-cy="warehouseAddress"
                    />
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </>}
        <Typography className={classes.typographyCards}>
          کالاهای محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container justifyContent='flex-end'>
              <Button
                // style={{ marginBottom: '24px' }}
                variant="outlined"
                color="primary"
                size="large"
                startIcon={<Icon path={mdiPlusCircle} size={1} />}
                onClick={() => {
                  setOpenAddItem(true);
                }}
                data-cy="addProduct"
              >
                {'افزودن کالا به محموله'}
              </Button>
            </Grid>
            <Grid container>
              {itemsInfo.length > 0 && (
                <AddItemsParcelsList
                  data={itemsInfo}
                  deleteItem={(body: any) => setConfirmDelete(body)}
                />
              )}
            </Grid>
          </CardContent>
        </Card>
        <Grid
          container
          justifyContent='flex-end'
        >
          <Button
            type="submit"
            size="medium"
            data-cy="saveBtn"
            variant="contained"
            color="primary"
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
                .length === 0
            }
          >
            {'ذخیره محموله '}
          </Button>
        </Grid>
      </form>
      <Dialog open={props.loading} aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <Typography variant="h4" style={{ padding: '100px' }}>
            در حال ذخیره محموله
          </Typography>
          <div className={classes.loadingTitle}>لطفا منتظر بمانید</div>
          <div style={{ textAlign: 'center', marginBottom: '35px' }}>
            <CircularProgress size={58} />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openConfirmDelete}
        fullWidth
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="large"
                data-cy="cancelRemove"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={deleteItemsToParcels}
                size="large"
                data-cy="confirmRemove"
                color="primary"
              >
                {'حذف کالا'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`ایا از ایجاد محموله برای انبار "${checkSubmit ? valueWarehouse?.name : ''
              }" مطمئنید؟`}
          </div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="outlined"
                color="primary"
                size="large"
                data-cy="cancelCreateParcel"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={handleCreateParcel}
                size="large"
                data-cy="confirmCreateParcel"
                color="primary"
              >
                {'ذخیره محموله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth="md"
        open={locationModal}
        onClose={() => setLocationModal(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={() => setLocationModal(false)}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <MapPosition
            style={{ height: '400px', width: '500px' }}
            zoom={14}
            center={{ lat: 35.6892, lng: 51.389 }}
            position={latLng}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              setLatLng(latLng);
            }}
          />
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                onClick={() => setLocationModal(false)}
                variant="contained"
                color="primary"
                size="large"
                data-cy="cancelCreateParcel"
              >
                {'تایید'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDimensions}
        onClose={handleCloseDimensions}
        fullWidth
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.addIcon}>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={4}>
              <TextField
                variant="outlined"
                fullWidth
                id="count"
                name="count"
                value={count}
                onChange={e => setCount(e.target.value)}
                label="تعداد"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                variant="outlined"
                fullWidth
                id="weight"
                name="weight"
                value={weight}
                onChange={e => setWeight(e.target.value)}
                label="وزن(گرم)"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                variant="outlined"
                select
                fullWidth
                value={size}
                label="سایز بسته‌بندی"
                onChange={(e) => setSize(e.target.value)}
                error={
                  !!errors.pickTime && !!errors.pickTime
                }
              >
                <MenuItem
                  value={'10'}
                  data-cy="time1"
                >
                  کوچک
                </MenuItem>
                <MenuItem
                  value={'15'}
                  data-cy="time2"
                >
                  متوسط
                </MenuItem>
                <MenuItem
                  value={'20'}
                  data-cy="time3"
                >
                  بزرگ
                </MenuItem>
              </TextField>
            </Grid>
            {dimensions.length !== 0 && (
              <Grid item xs={12}>
                <ListDimensions data={dimensions} modal />
              </Grid>
            )}
          </Grid>
          {/* <Divider style={{ width: '100%', margin: '16px 0  0' }} /> */}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={6} style={{ marginRight: "auto", marginLeft: "8px" }}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={addDimensions}
                variant="outlined"
                color="primary"
                disabled={checkButtonDisabled()}
                size="large"
                data-cy="addBox"
              >
                اضافه کردن بسته
              </Button>
              <Button
                variant="contained"
                onClick={setUpdateStatus}
                size="large"
                data-cy="cancelAddProduct"
                color="primary"
                disabled={dimensions.length == 0}
              >
                ثبت نهایی
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به محموله
          </Typography>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            addInventoryItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddItem(false)}
          />
        }
      />

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddInventoryItem(false)}
        open={openAddInventoryItem}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiArchiveOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <AddInventoryItemsParcelsForm
            product={productObject}
            variant={variantObject}
            count={itemCount}
            hasExpirationDate={hasExpirationDateTime}
            addItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddInventoryItem(false)}
          />
        }
      />
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcelsList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    createParcelsDispatch: (payload: PayloadCreate) =>
      dispatch(createParcelsActions(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Add);
